import { render } from "./CriarFerramentaEstoque.vue?vue&type=template&id=513a0e20&scoped=true"
import script from "./CriarFerramentaEstoque.vue?vue&type=script&lang=js"
export * from "./CriarFerramentaEstoque.vue?vue&type=script&lang=js"

import "./CriarFerramentaEstoque.vue?vue&type=style&index=0&id=513a0e20&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513a0e20"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QLinearProgress,QTable,QCard,QImg,QBtn,QTr,QTh,QTd,QPagination,QExpansionItem,QInput,QTooltip});
